import { render } from "./HotelContactPerson.vue?vue&type=template&id=36b9efbc&scoped=true"
import script from "./HotelContactPerson.vue?vue&type=script&lang=js"
export * from "./HotelContactPerson.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-36b9efbc"

export default script